var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.$appSettings.chatEnabled,
          expression: "$appSettings.chatEnabled",
        },
      ],
      staticClass: "bootstrap-iso",
      style: { bottom: _vm.$appSettings.verticalPlacement },
    },
    [
      _c("chat-popup", {
        attrs: {
          enabled: _vm.$appSettings.autoPromptEnabled,
          message: _vm.myhtml,
          delayInSeconds: _vm.$appSettings.popupDelaySecs,
        },
      }),
      _vm._v(" "),
      _c("chat-launcher"),
      _vm._v(" "),
      _c("chat-start"),
      _vm._v(" "),
      _c("chat-client"),
      _vm._v(" "),
      _c("chat-transcript"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }